import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M7.38915229,9.73621027 L6.3489069,10.6765033 L3.25778627,8 L6.3489069,5.32349675 L7.38915229,6.26378973 L5.35678675,7.98519224 L5.35678675,8.01480776 L7.38915229,9.73621027 Z M10.1666656,10.6765033 L9.12642026,9.73621027 L11.1587858,8.01480776 L11.1587858,7.98519224 L9.12642026,6.26378973 L10.1666656,5.32349675 L13.2577863,8 L10.1666656,10.6765033 Z"/>
  </svg>
);
